import { getRovoChatBridgeProduct } from './getRovoChatBridgeProduct';
import { type ConversationAssistantUIModes } from './types';

export type RovoChatXpcContextValues = {
	bridgeProduct: string;
	xpcProduct: string;
	xpcSubProduct: string | undefined;
};

export const getRovoChatXpcContextValues = ({
	mode,
	isFullScreen,
	xpcBridge,
	xpcProduct,
	xpcSubProduct,
	productKey,
}: {
	mode: ConversationAssistantUIModes | undefined;
	isFullScreen: boolean | undefined;
	xpcBridge: string | undefined;
	xpcProduct: string | undefined;
	xpcSubProduct: string | undefined;
	productKey: string;
}): RovoChatXpcContextValues => ({
	bridgeProduct: xpcBridge || getRovoChatBridgeProduct(mode, isFullScreen),
	xpcProduct: xpcProduct || productKey,
	xpcSubProduct,
});
